import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';

const MobileCardsContainer: React.FC<PropsWithChildren> = ({ children }) => (
  <Box sx={{ px: 2, py: 1, mx: -2, overflowY: 'auto', flex: '1 1 100px' }}>{children}</Box>
);

export default MobileCardsContainer;
